// import { useEffect, useState } from 'react'
// import { Link, useParams, useNavigate } from 'react-router-dom'
// import { useDispatch, useSelector } from 'react-redux'

// import Spinner from '../Layout/Spinner'
// import NotAuthorized from '../Others/NotAuthorized'

// import { getContract, updateContract } from "../../features/contractSlice"
// import { formatAddress, determineAuthorization, determineContract_Status, determineAccess } from '../../utils/Helper';
// import { status } from "../../utils/Constants"

// const EditContractSteps = () => {
//     let access = false;

//     const navigate = useNavigate()
//     const dispatch = useDispatch()
//     const { id } = useParams()

//     const [list, setList] = useState([])
//     const [editContract, setEditContract] = useState([])

//     const [step6Error, setStep6Error] = useState(false)
//     const [step7Error, setStep7Error] = useState(false)

//     const { role, email, idToken, agentEmail } = useSelector((state) => state.auth);
//     const { contract, subscriptions, agentInfo, loading, apiError, apiErrorMessage } = useSelector((state) => state.contracts)

//     useEffect(() => {
//         const contract_id = id
//         dispatch(getContract({ contract_id, idToken }))
//         setEditContract(contract)
//         setList(contract.steps)
//     }, [])

//     let { msg, active } = determineAuthorization(role, subscriptions, agentInfo)

//     const handleChangeDueDate = (index, field, value) => {

//         const newList = list.map((item, i) => {
//             if (i === index) {
//                 const newObj = { ...item, "due_date": value }
//                 return newObj
//             } else {
//                 return item
//             }
//         })
//         setList(newList)

//         if (index === 4) {
//             setStep6Error(true)
//         } else {
//             setStep6Error(false)
//         }

//         if (index === 5) {
//             setStep7Error(true)
//         } else {
//             setStep7Error(false)
//         }
//     }

//     const handleChangeStatus = (index, field, value) => {

//         const newList = list.map((item, i) => {
//             if (i === index) {
//                 const newObj = { ...item, "status": value }
//                 return newObj
//             } else {
//                 return item
//             }
//         })
//         setList(newList)
//     }

//     const handleChangeComments = (index, field, value) => {

//         const newList = list.map((item, i) => {
//             if (i === index) {
//                 const newObj = { ...item, "comments": value }
//                 return newObj
//             } else {
//                 return item
//             }
//         })
//         setList(newList)
//     }

//     const submitFormData = (e) => {
//         e.preventDefault()

//         const step_12_date = list[11].due_date

//         const newList = list.map((item, i) => {
//             if (i === 12) {
//                 const newObj = { ...item, "due_date": step_12_date }
//                 return newObj
//             } else {
//                 return item
//             }
//         })

//         const status = determineContract_Status(newList)
//         const data = { ...editContract, contract_status: status, closing_date: step_12_date, steps: newList }

//         dispatch(updateContract({ data, idToken }))
//             .unwrap()
//             .then(() => {
//                 navigate(`/contract-details/${data.contract_id}`);
//             })
//             .catch((error) => {
//                 console.error('Error creating contract:', error);
//             });

//     }

//     access = determineAccess(role, email, agentEmail, contract)

//     if (!access) return <NotAuthorized />

//     if (loading) return <Spinner />

//     return (
//         <div className='min-h-screen'>
//             <div className='container-xl lg:container m-auto px-4 py-6'>
//                 <div className='text-2xl text-center font-semibold mb-6 uppercase'>Workflow</div>
//                 <div className='font-bold text-xl m-5'>Address - {formatAddress(contract.address, contract.apartment, contract.city, contract.state, contract.zipcode)}</div>
//                 <form onSubmit={submitFormData}>
//                     {list.map((step, index) => {
//                         return <div key={index} >
//                             <div className='text-center flex flex-col md:grid md:gap-2 md:grid-cols-7 mb-4' >
//                                 <div className='col-span-1 m-2 text-center font-bold'>Step {step.step}</div >
//                                 <div className='col-span-2 m-2 text-left'>{step.title}</div>

//                                 <input
//                                     className={`col-span-1 block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40 ${((step6Error && (index === 5)) || (step7Error && (index === 6))) ? " text-red-500" : ""}`}
//                                     type="date"
//                                     value={step.due_date}
//                                     pattern="\d{4}-\d{2}-\d{2}"
//                                     onChange={(e) => handleChangeDueDate(index, "due_date", e.target.value)}
//                                 // onChange={e => {
//                                 //     list[index].due_date = e.target.value
//                                 //     index === 4 ? setStep6Error(true) : setStep6Error(false)
//                                 //     index === 5 ? setStep7Error(true) : setStep7Error(false)
//                                 //     setList([...list])
//                                 // }}
//                                 />

//                                 <select
//                                     className='col-span-1 block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opaci ty-40'
//                                     value={step.status}
//                                     onChange={(e) => handleChangeStatus(index, "status", e.target.value)}
//                                 // onChange={e => {
//                                 //     list[index].status = e.target.value
//                                 //     setList([...list])
//                                 // }}
//                                 >
//                                     <option>Select Status</option>
//                                     {status.map((s, i) => (
//                                         <option key={i}>{s}</option>
//                                     ))}
//                                 </select>

//                                 <input
//                                     className='col-span-2 block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                     value={step.comments}
//                                     placeholder="Notes"
//                                     onChange={(e) => handleChangeComments(index, "comments", e.target.value)}
//                                 // onChange={e => {
//                                 //     list[index].comments = e.target.value
//                                 //     setList([...list])
//                                 // }}
//                                 />

//                             </div >
//                             {step6Error && (index === 4) ?
//                                 <div className='text-center text-red-500 text-sm italic'>Change Date on Step 6 accordingly</div>
//                                 : null}
//                             {step7Error && (index === 5) ?
//                                 <div className='text-center text-red-500 text-sm italic'>Change Date on Step 7 accordingly</div>
//                                 : null}
//                         </div>
//                     })}

//                     <div className='flex justify-between mt-5'>
//                         <button
//                             className='uppercase h-[36px] bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg text-center text-sm'>
//                             <Link to="/">Dashboard</Link>

//                         </button>
//                         <button
//                             className='uppercase h-[36px] bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg text-center text-sm'
//                             type="submit">
//                             Save Contract
//                         </button>
//                     </div>
//                 </form >
//             </div>

//         </div >
//     )
// }

// export default EditContractSteps

import { useEffect, useState } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import Spinner from '../Layout/Spinner'
import NotAuthorized from '../Others/NotAuthorized'

import { getContract, updateContract } from "../../features/contractSlice"
import { formatAddress, determineAuthorization, determineContract_Status, determineAccess } from '../../utils/Helper';
import { status } from "../../utils/Constants"

const EditContractSteps = () => {
    let access = false;

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams()

    const [list, setList] = useState([])
    const [editContract, setEditContract] = useState([])
    const [closingDate, setClosingDate] = useState('')
    const [salePrice, setSalePrice] = useState('')

    const [step6Error, setStep6Error] = useState(false)
    const [step7Error, setStep7Error] = useState(false)

    const { role, email, idToken, agentEmail } = useSelector((state) => state.auth);
    const { contract, subscriptions, agentInfo, loading, apiError, apiErrorMessage } = useSelector((state) => state.contracts)

    useEffect(() => {
        const contract_id = id
        dispatch(getContract({ contract_id, idToken }))
    }, [])

    useEffect(() => {
        if (contract && contract.contract_id) {
            setEditContract(contract)
            setList(contract.steps || [])
            setClosingDate(contract.closing_date || '')
            setSalePrice(contract.sale_price || '')
        }
    }, [contract])

    let { msg, active } = determineAuthorization(role, subscriptions, agentInfo)

    const handleChangeDueDate = (index, field, value) => {
        const newList = list.map((item, i) => {
            if (i === index) {
                return { ...item, "due_date": value }
            } else {
                return item
            }
        })
        setList(newList)

        if (index === 4) {
            setStep6Error(true)
        } else {
            setStep6Error(false)
        }

        if (index === 5) {
            setStep7Error(true)
        } else {
            setStep7Error(false)
        }
    }

    const handleChangeStatus = (index, field, value) => {
        const newList = list.map((item, i) => {
            if (i === index) {
                return { ...item, "status": value }
            } else {
                return item
            }
        })
        setList(newList)
    }

    const handleChangeComments = (index, field, value) => {
        const newList = list.map((item, i) => {
            if (i === index) {
                return { ...item, "comments": value }
            } else {
                return item
            }
        })
        setList(newList)
    }

    const handleChangeClosingDate = (value) => {
        setClosingDate(value)
        // Update Step 12 (index 11) and Step 13 (index 12) due_date to match closing date
        const newList = list.map((item, i) => {
            if (i === 11 || i === 12) {
                return { ...item, "due_date": value }
            } else {
                return item
            }
        })
        setList(newList)
    }

    const handleChangeSalePrice = (value) => {
        setSalePrice(value)
    }

    const submitFormData = (e) => {
        e.preventDefault()

        // Use the closingDate state instead of deriving from Step 12
        // Update Step 12 (index 11) and Step 13 (index 12) to match closing date
        const newList = list.map((item, i) => {
            if (i === 11 || i === 12) {
                return { ...item, "due_date": closingDate }
            } else {
                return item
            }
        })

        const status = determineContract_Status(newList)
        const data = {
            ...editContract,
            contract_status: status,
            closing_date: closingDate,
            sale_price: salePrice && salePrice.toString().trim() !== '' ? parseFloat(salePrice) : null,
            steps: newList
        }

        dispatch(updateContract({ data, idToken }))
            .unwrap()
            .then(() => {
                navigate(`/contract-details/${data.contract_id}`);
            })
            .catch((error) => {
                console.error('Error creating contract:', error);
            });
    }

    access = determineAccess(role, email, agentEmail, contract)

    if (!access) return <NotAuthorized />
    if (loading) return <Spinner />

    // Helper function to determine status badge color
    const getStatusColor = (status) => {
        switch (status.toLowerCase()) {
            case 'completed':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'in progress':
                return 'bg-blue-100 text-blue-800 border-blue-200';
            case 'pending':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case 'overdue':
                return 'bg-red-100 text-red-800 border-red-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    return (
        <div className="bg-gray-50 min-h-screen py-8">
            <div className="max-w-6xl mx-auto px-4">
                <div className="mb-8 flex items-center justify-between">
                    <Link
                        to={`/contract-details/${id}`}
                        className="inline-flex items-center text-gray-600 hover:text-gray-900"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                        </svg>
                        Back to Contract Details
                    </Link>
                </div>

                <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-8">
                    <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4">
                        <h1 className="text-xl font-bold text-white">Edit Workflow Timeline</h1>
                    </div>

                    <div className="p-6">
                        <div className="flex items-center mb-6">
                            <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 mr-3">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-semibold text-gray-800">
                                {formatAddress(contract.address, contract.apartment, contract.city, contract.state, contract.zipcode)}
                            </h2>
                        </div>

                        {/* Closing Date and Sales Price Fields */}
                        <div className="mb-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                            {/* Closing Date Field */}
                            <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Closing Date
                                </label>
                                <input
                                    type="date"
                                    value={closingDate}
                                    pattern="\d{4}-\d{2}-\d{2}"
                                    onChange={(e) => handleChangeClosingDate(e.target.value)}
                                    className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                />
                                <p className="mt-2 text-xs text-gray-600">
                                    Updating the closing date will automatically update Step 12 and Step 13 due dates.
                                </p>
                            </div>

                            {/* Sales Price Field */}
                            {(role === "Agent" || role === "Transaction Coordinator") && (
                                <div className="p-4 bg-green-50 rounded-lg border border-green-200">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Sales Price
                                    </label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <span className="text-gray-500 sm:text-sm">$</span>
                                        </div>
                                        <input
                                            type="number"
                                            value={salePrice}
                                            onChange={(e) => handleChangeSalePrice(e.target.value)}
                                            placeholder="0.00"
                                            className="block w-full pl-7 pr-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                        <form onSubmit={submitFormData}>
                            {/* Desktop Table View */}
                            <div className="hidden md:block overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead>
                                        <tr className="bg-gray-50">
                                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-16">Step</th>
                                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Task</th>
                                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-40">Due Date</th>
                                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-40">Status</th>
                                            <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Notes</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {list.map((step, index) => (
                                            <tr key={index} className="hover:bg-gray-50">
                                                <td className="px-4 py-4">
                                                    <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold">
                                                        {step.step}
                                                    </div>
                                                </td>
                                                <td className="px-4 py-4">
                                                    <div className="text-sm font-medium text-gray-900">{step.title}</div>
                                                </td>
                                                <td className="px-4 py-4">
                                                    <input
                                                        type="date"
                                                        value={step.due_date}
                                                        pattern="\d{4}-\d{2}-\d{2}"
                                                        onChange={(e) => handleChangeDueDate(index, "due_date", e.target.value)}
                                                        className={`block w-full px-3 py-2 border ${((step6Error && (index === 5)) || (step7Error && (index === 6))) ? "border-red-300 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"} rounded-md shadow-sm focus:outline-none focus:border-blue-500 sm:text-sm`}
                                                    />
                                                    {step6Error && (index === 4) && (
                                                        <p className="mt-1 text-xs text-red-600">Change Date on Step 6 accordingly</p>
                                                    )}
                                                    {step7Error && (index === 5) && (
                                                        <p className="mt-1 text-xs text-red-600">Change Date on Step 7 accordingly</p>
                                                    )}
                                                </td>
                                                <td className="px-4 py-4">
                                                    <select
                                                        value={step.status}
                                                        onChange={(e) => handleChangeStatus(index, "status", e.target.value)}
                                                        className={`block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${getStatusColor(step.status)}`}
                                                    >
                                                        <option>Select status</option>
                                                        {status.map((s, i) => (
                                                            <option key={i} value={s}>{s}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                                <td className="px-4 py-4">
                                                    <input
                                                        type="text"
                                                        value={step.comments}
                                                        placeholder="Add notes here"
                                                        onChange={(e) => handleChangeComments(index, "comments", e.target.value)}
                                                        className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Mobile Card View */}
                            <div className="md:hidden space-y-4 mt-4">
                                {list.map((step, index) => (
                                    <div key={index} className="bg-gray-50 rounded-lg border border-gray-200 p-4">
                                        <div className="flex items-center justify-between mb-4">
                                            <div className="flex items-center">
                                                <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold mr-3">
                                                    {step.step}
                                                </div>
                                                <span className="font-medium text-gray-900 text-sm">Step {step.step}</span>
                                            </div>
                                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(step.status)} flex-shrink-0`}>
                                                {step.status || 'Select status'}
                                            </span>
                                        </div>

                                        <div className="mb-4">
                                            <h4 className="font-medium text-gray-900 text-sm leading-tight mb-2">{step.title}</h4>
                                        </div>

                                        <div className="space-y-4">
                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">Due Date</label>
                                                <input
                                                    type="date"
                                                    value={step.due_date}
                                                    pattern="\d{4}-\d{2}-\d{2}"
                                                    onChange={(e) => handleChangeDueDate(index, "due_date", e.target.value)}
                                                    className={`block w-full px-3 py-2 border ${((step6Error && (index === 5)) || (step7Error && (index === 6))) ? "border-red-300 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"} rounded-md shadow-sm focus:outline-none focus:border-blue-500 text-sm`}
                                                />
                                                {step6Error && (index === 4) && (
                                                    <p className="mt-1 text-xs text-red-600">Change Date on Step 6 accordingly</p>
                                                )}
                                                {step7Error && (index === 5) && (
                                                    <p className="mt-1 text-xs text-red-600">Change Date on Step 7 accordingly</p>
                                                )}
                                            </div>

                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">Status</label>
                                                <select
                                                    value={step.status}
                                                    onChange={(e) => handleChangeStatus(index, "status", e.target.value)}
                                                    className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm"
                                                >
                                                    <option>Select status</option>
                                                    {status.map((s, i) => (
                                                        <option key={i} value={s}>{s}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div>
                                                <label className="block text-xs font-medium text-gray-700 mb-1">Notes</label>
                                                <input
                                                    type="text"
                                                    value={step.comments}
                                                    placeholder="Add notes here"
                                                    onChange={(e) => handleChangeComments(index, "comments", e.target.value)}
                                                    className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="mt-8 flex justify-between">
                                <Link
                                    to="/dashboard"
                                    className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                    </svg>
                                    Dashboard
                                </Link>
                                <button
                                    type="submit"
                                    className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    Save Changes
                                </button>
                            </div>
                        </form>

                    </div>
                </div>

                {apiError && (
                    <div className="mt-4 p-4 bg-red-50 border-l-4 border-red-400 rounded">
                        <p className="text-sm text-red-700">{apiErrorMessage}</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default EditContractSteps
